import { render, staticRenderFns } from "./not-data.vue?vue&type=template&id=32c2af42&scoped=true"
import script from "./not-data.vue?vue&type=script&lang=js"
export * from "./not-data.vue?vue&type=script&lang=js"
import style0 from "./not-data.vue?vue&type=style&index=0&id=32c2af42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2af42",
  null
  
)

export default component.exports